import { Button } from 'react-aria-components'
import { useTranslation } from 'react-i18next'
import { UITooltipResponsive } from '../HelpIcon'

export const UserVerificationInfo = ({
  accountType,
}: {
  accountType?: string
}) => {
  switch (accountType) {
    case 'official': {
      return <OfficialAccountBadge />
    }
    default: {
      return null
    }
  }
}

export const OfficialAccountBadge = () => {
  const { t } = useTranslation(['user'])

  return (
    <UITooltipResponsive
      trigger={open => {
        return (
          <Button
            className="inline-flex items-center justify-center size-5 bg-blue-500 rounded-full text-white text-xs"
            onClick={open}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 3L4.5 8.5L2 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Button>
        )
      }}
    >
      <div className="px-3 py-1.5 text-sm font-medium text-gray-900 bg-white rounded-lg">
        {t('user:account-type.official')}
      </div>
    </UITooltipResponsive>
  )
}
